import { isNil } from 'lodash';
import { useEffect, useState } from 'react';

import StorefrontPredictiveSearch from 'api/StorefrontPredictiveSearch';

const predictiveSearchResourcesTypes = {
  QUERIES: 'queries',
};

const buildEmptyQueriesArray = () => [
  {
    text: '',
    trackingParameters: '',
  },
];

const builldPredictiveSearchResultState = ({ queries, predictiveSearchHasError }) => {
  return {
    queries: queries || buildEmptyQueriesArray(),
    predictiveSearchHasError: predictiveSearchHasError || false,
  };
};

const useShopifyPredictiveSearch = ({ predictiveResourceType, limitPredictiveResult }) => {
  const [preditiveSearchValueState, setPredictiveSearchValueState] = useState(undefined);
  const [predictiveSearchResultState, setPredictiveSearchResultState] = useState(() =>
    builldPredictiveSearchResultState({})
  );

  const shopifyPredictiveSearchCall = async ({ queryToSearch }) => {
    if (isNil(queryToSearch) || queryToSearch === '') {
      return;
    }

    try {
      // Handle predictive search for 'queries' type
      if (predictiveResourceType == predictiveSearchResourcesTypes.QUERIES) {
        const { queriesObjResult } = await StorefrontPredictiveSearch.predictiveSearchQueries({
          queryToSearch,
          limitResult: limitPredictiveResult,
        });

        setPredictiveSearchResultState(() =>
          builldPredictiveSearchResultState({
            queries: queriesObjResult,
            predictiveSearchHasError: false,
          })
        );
      }

      // we can expand to other resource types like 'PRODUCTS', 'COLLECTIONS', 'PAGES',
    } catch (e) {
      setPredictiveSearchResultState(() =>
        builldPredictiveSearchResultState({ predictiveSearchHasError: true })
      );
    }
  };

  useEffect(() => {
    (async () => {
      await shopifyPredictiveSearchCall({
        queryToSearch: preditiveSearchValueState,
      });
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [preditiveSearchValueState]);

  return {
    preditiveSearchValueState,
    setPredictiveSearchValueState,
    predictiveSearchResultState,
  };
};

export { useShopifyPredictiveSearch, predictiveSearchResourcesTypes };
